/* global I18n  */

import screen from "screen"
import signals from "signals"
import {Controller} from "@hotwired/stimulus"

class HeadwayController extends Controller {
  connect() {
    // if the screen is mobile, we don't want to load the desktop changelog
    if (screen.is_md_screen() && this.element.id === "desktop_changelog") return
    // if the screen is desktop, we don't want to load the mobile changelog
    if (!screen.is_md_screen() && this.element.id === "mobile_changelog") return

    load_heaway().then(() =>
      window.Headway?.init({
        selector: `#${this.element.id}`,
        account: window.gon.headway_account,
        callbacks: {
          onShowWidget: () => signals.emit("kenhub.changelog_clicked")
        },
        translations: {
          title: I18n.t("js.headway.title"),
          readMore: I18n.t("js.headway.read_more"),
          labels: {
            new: I18n.t("js.headway.new"),
            improvement: I18n.t("js.headway.improvement"),
            fix: I18n.t("js.headway.fix")
          }
        }
      })
    )
  }

  disconnect() {
    // clearing the inner HTML of the selector
    // to avoid headway adding it more than once
    if (this.hasDesktopContainerTarget) {
      this.desktopContainerTarget.innerHTML = ""
    }
    if (this.hasMobileContainerTarget) {
      this.mobileContainerTarget.innerHTML = ""
    }
  }
}

function load_heaway() {
  if (window.Headway) return Promise.resolve()
  return new Promise((resolve) => {
    const t = document.createElement("script")
    const s = document.getElementsByTagName("script")[0]
    t.async = true
    t.id = "headway"
    t.src = "https://cdn.headwayapp.co/widget.js"
    t.onload = resolve
    return s.parentNode.insertBefore(t, s)
  })
}

export default HeadwayController
